import { simpleFetch } from './customFetch';

export const getCartsTimers = (membershipTier?: string) =>
  simpleFetch(
    'api/1/carts/timers' + (membershipTier ? `?membershipTier=${membershipTier}` : ''),
    {},
    process.env.REACT_APP_ACE_API,
  );
